/**
 * Notification API Endpoints
 * Константы endpoints для микросервиса notification.
 */

export const NotificationEndpoints = {
  Notification: "notifications",
  NotificationUnreadCount: "notifications/unread-count",
  NotificationMarkAsRead: "notifications/{id}/mark-as-read",
  NotificationMarkAllAsRead: "notifications/mark-all-as-read",
} as const;
